import moment from 'moment'
import { LKDate } from 'loankeeper-common/helpers/Date'
import { fieldTypes, fieldDefaultValue } from './constants'

export const formattedDate = (dateval) =>
  dateval.length === 10
    ? moment(dateval, 'DD.MM.YYYY', true).format('DD.MM.YYYY')
    : moment(dateval, 'YYYY-MM-DD HH:mm:ss', true).format('DD.MM.YYYY')

export const getSubmitData = (values) => {
  const dynamicFieldsArray = Object.keys(values || {})

  return {
    DynFieldData: dynamicFieldsArray.map((dynFieldKey) => ({
      Name: dynFieldKey,
      Value: values[dynFieldKey].toString(),
    })),
  }
}

export const getDefValInRangeValue = (field, isCheckRequired, defaultValue) => {
  let result = defaultValue
  if (fieldTypes[field.FieldDataType] === 'number' || fieldTypes[field.FieldDataType] === 'float') {
    if ((!isCheckRequired || field.RequiredField === 1) && field.FieldDefData) {
      const validators = field.FieldDefData.split(';')

      // it would be nice to switch foreach with reduce
      validators.forEach((validator, i) => {
        const rules = validator.split('=')

        if (rules[0].indexOf('Validate') !== -1 && parseInt(rules[1], 10) === 1) {
          const minCheck = validators[i + 1].split('=')
          const maxCheck = validators[i + 2].split('=')
          let minValue
          let maxValue

          if (fieldTypes[field.FieldDataType] === 'number') {
            minValue = parseInt(minCheck[1], 0)
            maxValue = parseInt(maxCheck[1], 0)
          } else if (fieldTypes[field.FieldDataType] === 'float') {
            minValue = parseFloat(minCheck[1])
            maxValue = parseFloat(maxCheck[1])
          }
          if (defaultValue < minValue || defaultValue > maxValue) {
            result = minValue
          }
        }
      })
    }
  }
  return result
}

export const getMinRangeValue = (field) => {
  let minValue
  if (fieldTypes[field.FieldDataType] === 'number' || fieldTypes[field.FieldDataType] === 'float') {
    if (field.FieldDefData) {
      const validators = field.FieldDefData.split(';')

      // it would be nice to switch foreach with reduce
      validators.forEach((validator, i) => {
        const rules = validator.split('=')

        if (rules[0].indexOf('Validate') !== -1 && parseInt(rules[1], 10) === 1) {
          const minCheck = validators[i + 1].split('=')

          if (fieldTypes[field.FieldDataType] === 'number') {
            minValue = parseInt(minCheck[1], 0)
          } else if (fieldTypes[field.FieldDataType] === 'float') {
            minValue = parseFloat(minCheck[1])
          }
        }
      })
    }
  }
  return minValue
}

export const getMaxRangeValue = (field) => {
  let maxValue
  if (fieldTypes[field.FieldDataType] === 'number' || fieldTypes[field.FieldDataType] === 'float') {
    if (field.FieldDefData) {
      const validators = field.FieldDefData.split(';')

      // it would be nice to switch foreach with reduce
      validators.forEach((validator, i) => {
        const rules = validator.split('=')

        if (rules[0].indexOf('Validate') !== -1 && parseInt(rules[1], 10) === 1) {
          const maxCheck = validators[i + 2].split('=')

          if (fieldTypes[field.FieldDataType] === 'number') {
            maxValue = parseInt(maxCheck[1], 0)
          } else if (fieldTypes[field.FieldDataType] === 'float') {
            maxValue = parseFloat(maxCheck[1])
          }
        }
      })
    }
  }
  return maxValue
}

export const getMinMaxRange = (field) => {
  let minMaxRange
  if (fieldTypes[field.FieldDataType] === 'number' || fieldTypes[field.FieldDataType] === 'float') {
    if (field.RequiredField === 1 && field.FieldDefData) {
      const validators = field.FieldDefData.split(';')

      // it would be nice to switch foreach with reduce
      validators.forEach((validator, i) => {
        const rules = validator.split('=')

        if (rules[0].indexOf('Validate') !== -1 && parseInt(rules[1], 10) === 1) {
          const minCheck = validators[i + 1].split('=')
          const maxCheck = validators[i + 2].split('=')
          let minValue
          let maxValue

          if (fieldTypes[field.FieldDataType] === 'number') {
            minValue = parseInt(minCheck[1], 0)
            maxValue = parseInt(maxCheck[1], 0)
          } else if (fieldTypes[field.FieldDataType] === 'float') {
            minValue = parseFloat(minCheck[1])
            maxValue = parseFloat(maxCheck[1])
          }
          minMaxRange = {
            min: minValue,
            max: maxValue,
          }
        }
      })
    }
  }
  return minMaxRange
}

const getBestDefaultValue = (field) => {
  let defValue = field.DefaultValue
  if (!defValue) {
    defValue = fieldDefaultValue[field.FieldDataType]
  }

  return defValue
}

export const getInitialValues = (fields) =>
  fields.reduce((result, curr) => {
    let defValue = getBestDefaultValue(curr) // if (!defValue)

    if (curr.FieldDataType === 0) {
      if (!defValue) defValue = 1
      else defValue = parseInt(defValue, 10)
    }

    if (curr.FieldDataType === 8) {
      const parentSelect = fields.find(
        (dynamicField) => parseInt(dynamicField.ID, 10) === parseInt(curr.ParentFieldID, 10),
      )
      let filteredOptions

      if (parentSelect) {
        filteredOptions = curr.LookupData.filter(
          (cur) => parseInt(cur.ParentID, 10) === parseInt(parentSelect.DefaultValue, 10),
        )
      }

      defValue = filteredOptions && filteredOptions[0] ? filteredOptions[0].ID : ''
    }

    if (LKDate.isValidFormat(defValue)) {
      defValue = formattedDate(defValue)
    }

    return {
      ...result,
      [curr.FieldName]: defValue,
    }
  }, {})
